export const NavBarNames = {
  customer: 'Customer',
  segments: 'Segments',
  customerGroup: 'Customer Lists',
  levels: 'Levels',
  records: 'Records',
  campaigns: 'Campaigns',
  stampCampaigns: 'Stamp Campaigns',
  campaignCategory: 'Campaign Categories',
  message: 'Messages',
  earnRules: 'Earning Rules',
  coupons: 'Coupons & Tickets',
  giftCards: 'Gift Cards',
  giftCardRecords: 'Gift Card Records',
  rewards: 'Rewards',
  mall: 'Mall',
  brands: 'Brands',
  stores: 'Stores',
  storeCodes: 'Store Code List',
  storeCategory: 'Store Categories',
  translations: 'Translations',
  transactions: 'Transactions',
  bulkRewards: 'Bulk rewards update',
  stampRecords: 'Stamp records',
  pointRecords: 'Point Records',
  couponRecords: 'Coupon Records',
  others: 'Webview content',
  admin: 'Users',
  adminGroup: 'Permission Groups',
  dashboard: 'Dashboard',
  dashboardCampaignAndRedemption: 'Earn & Burn',
  metricTable: 'Metric Table',
  dashboardDemographic: 'Demographics',
  dashboardSales: 'Sales',
  banners: 'Banners',
  productCategory: 'Product categories',
  featuredCampaign: 'Featured Campaigns',
  featuredProduct: 'Featured products',
  langauge: 'Languages',
  levelDiscount: 'Level Benefits',
  webview: 'Webview content',
  rfm: 'RFM',
  messageCreditRecords: 'Message Credit Records',
  appUpdate: 'App Update',
  maintenance: 'Maintenance',
};
